import './index.scss';
import React, { PropTypes }  from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';

const preventDefault = e => {
    e.preventDefault();
};

const DisableableLink = React.createClass({
    propTypes: {
        disabled: PropTypes.bool,
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
        className: PropTypes.string
    },
    render: function () {
        const { disabled, children, className, ...other } = this.props;

        return (
            <Link className={classNames(className, { 'disabled' : disabled })} onClick={disabled ? preventDefault : null} {...other}>
                {children}
            </Link>);
    }
});

export default DisableableLink;


// WEBPACK FOOTER //
// ./src/components/common/DisableableLink/index.jsx